import React from 'react';
import { Stack } from '../../../atoms/stack/Stack';
import { Typography } from '../../../atoms/typography/Typography';
import { CollapseItem } from '../../../molecules/category/collapseItem/CollapseItem';

export const CollapseSection = ({ section }) => {
  const halfLength = Math.ceil(section.componentData.length / 2);
  const firstHalf = section.componentData.slice(0, halfLength);
  const secondHalf = section.componentData.slice(halfLength);

  return (
    <Stack className="flex-1 bg-primary-900 py-20 mt-20">
      <div className="flex w-full flex-col flex-1 px-8 lg:mx-auto my-5 max-w-6xl">
        <div className="flex flex-col md:flex-row flex-1 justify-between py-4 gap-10 md:gap-2">
          <Stack className="flex-1">
            <Typography
              textAlign="left"
              fontVariant="h8"
              className="!text-secondary-400"
            >
              {section.label}
            </Typography>
            <Typography
              as="h2"
              textAlign="left"
              fontVariant="h4"
              className="!text-white"
            >
              {section.title}
            </Typography>
            <div className="flex flex-col md:flex-row flex-1 w-full mt-10 gap-4 md:gap-20">
              <Stack className="gap-4 flex-1">
                {firstHalf.map((item) => (
                  <CollapseItem
                    key={item.title}
                    title={item.title}
                    text={item.text}
                  />
                ))}
              </Stack>
              <Stack className="gap-4 flex-1">
                {secondHalf.map((item) => (
                  <CollapseItem
                    key={item.title}
                    title={item.title}
                    text={item.text}
                  />
                ))}
              </Stack>
            </div>
          </Stack>
        </div>
      </div>
    </Stack>
  );
};
